
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
require('./components/jquery/scrollcontrol');
require('./components/jquery/admin');
require('./components/jquery/jquery.playSound');
require('./components/jquery/sidebartoggle');
require('./components/jquery/sidebartogglev2');
require('./components/jquery/socialmedia');
require('./components/jquery/businessgroup');
require('./components/jquery/forms');
require('./components/jquery/feedbackscripts');
require('./components/redux/FeedbackRedux');
require('./components/layouts/Dashboard');
